//@ts-nocheck
import React, { useState } from "react";
import bulbIcon from "../../assets/13b944b8c44d78a19696d4183e2f4b0edab1b89f.png";
import WarningIcon from "@material-ui/icons/Warning";
import { Typography, Grid, withStyles, createStyles, makeStyles, IconButton, Button, Snackbar } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { withRouter, RouterProps } from "react-router";
import withAlertBox, { withAlertBoxProps } from "../../../../components/src/withAlertBox.Web";
import withToast, { withToastProps } from "../../../../components/src/withSnackBar.Web";
import Tooltip from "@material-ui/core/Tooltip";
import withLoader, { withLoaderProps } from "../../../../components/src/withLoader.Web";
import withDialog from "../../../../components/src/withDialog.web";
import withConfirmBox from "../../../../components/src/withConfirmBox.Web";
import StorageProvider from "../../../../framework/src/StorageProvider.web";
import PackageDetail from "./PackageDetail.web";
import ControlPointIcon from "@material-ui/icons/ControlPoint";
import {
  packageSelect,
  customPackage,
  ListViewIcon,
  GridViewIcon,
} from "../assets";
import {
  Rocket,
  FileText,
  FilePlus,
  Activity,
  Layers,
  BarChart2,
  Target,
  ClipboardList,
  TrendingUp,
  Users,
  Heart,
  Shield,
  User,
  FileCheck,
  FileBarChart,
  FileBarChart2,
} from "lucide-react";


import CustomTypography from "../../../../components/src/CustomTypography.web";
import { formatCurrency } from "../CustomPackage/CustomPackageCreationSelectFeaturesPage.web";
import { DialogProps } from "../../../../components/src/DialogContext";
import ToggleButton from "../ToggleButton.web";
import PackageGridCard from "./PackageGridCard.web";
import PackageListRow from "./PackageListRow.web";

export type Props = RouterProps &
  DialogProps &
  withAlertBoxProps &
  withToastProps &
  withLoaderProps & {
    id: string;
    selectedPackageList: [];
    // Customizable Area Start
    // Customizable Area End
};

const PACKAGE_ICON_MAP = {
  // Figma names
  "New Business Startup":                Rocket,
  "Tax Prep Only - Business":            FileText,
  "Tax Prep Plus - Business":            FilePlus,
  "Business Tax & Planning":             Activity,
  "Business Bundle":                     Layers,
  "CFO Management":                      BarChart2,
  "Accounting - Support":                  Target,
  "Accounting - Full Service":             ClipboardList,
  "Accounting - Growth":                   TrendingUp,
  "Payroll Success":                     Users,
  "Non-Profit Bundle":                   Heart,
  "Trust-Fiduciary Support":             Shield,
  "Tax Prep Only - Personal":            FileText,
  "Tax Prep Plus - Personal":            FileCheck,
  "Personal Bundle":                     User,
  "IRS Rapid Relief":                    Shield,
};

const QuizTooltip = withStyles((theme: Theme) =>
  createStyles({
    arrow: {
      color: "#fff",
    },
    tooltip: {
      boxShadow: "rgba(0, 0, 0, 0.15) 0px 15px 25px, rgba(0, 0, 0, 0.05) 0px 5px 10px",
      padding: "24px",
      fontFamily: "Lato",
      fontSize: "1.2rem",
      backgroundColor: "#FEFEFE",
      borderRadius: "12px",
    },
  })
)(Tooltip);

const useCustomColorTooltipStyles = makeStyles((theme) => ({
  arrow: {
    color: (props) => {
      return props.color ? props.color : "#FCC65A";
    },
    marginLeft: "-1.20em!important",
  },
  popper: {
    width: "35%",
  },
  tooltip: {
    fontFamily: "Lato",
    fontSize: "0.8rem",
    fontWeight: 600,
    backgroundColor: "#fff",
    color: (props) => {
      return props.color ? props.color : theme.palette.text.blue2;
    },
    border: (props) => {
      return props.color ? `1px solid ${props.color}` : `1px solid ${theme.palette.text.blue2}`;
    },
    maxWidth: 1200,
    borderRadius: "8px",
  },
}));

function CustomColorTooltip(props: TooltipProps) {
  const classes = useCustomColorTooltipStyles(props);

  return <Tooltip classes={classes} {...props} />;
}

const QuizDialog = ({ classes }) => {
  return (
    <Grid container justifyContent="space-between" className={classes.dialogBox}>
      <Grid xs={8}>
        <Typography className={classes.tooltipHeading}>Need help selecting a package for this client?</Typography>
      </Grid>
      <Grid item container justifyContent="center" alignItems="center" xs={4}>
        <img className={classes.bulbIcon} src={bulbIcon} />
      </Grid>
    </Grid>
  );
};

export class PackageList extends React.Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      viewType: "grid"
    }
  }

  async componentDidMount() {
    const token = await StorageProvider.get("authToken");
    if (token) {
      this.props.getPackages();
    }
  }

  setSelectedPackage = (value) => {
    this.props.setState(
      {
        selectedPackageType: value,
      },
      () => {
        this.props.setPackageType(this.props.selectedPackageType);
      }
    );
  }

  openDialogDetail = (data) => {
    this.props
      .openDialogBox({
        dataToPass: {
          name: data.name,
          logo: this.getPackageImage(data.name),
          description: data.description,
          price: data.price,
          id: data.id,
          selectedCurrentPackage: this.props.selectedCurrentPackage,
          package: data.package,
        },
        renderedComponent: PackageDetail,
        withCustomDialog: false,
      })
      .then((pkg) => {
        if (pkg) {
          this.selectCurrentPackage(pkg);
        }
      });
  };
  selectCurrentPackage = (pkg) => {
    const slctPkg = pkg?.attributes?.custom_package_managements?.data || pkg
    this.props.setState(
      {
        selectedCurrentPackage: slctPkg,
      },
      () => {
        this.props.setSelectedPackageList(this.props.selectedCurrentPackage);
      }
    );
  };

  getPackageImage = (packageName) => {
    return PACKAGE_ICON_MAP[packageName] ?? packageSelect;
  };

  getPackagePrices = (pkg) => {
    if (pkg?.attributes?.custom_package_managements?.data?.id) {
      return `$ ${(formatCurrency.format(Math.round(pkg?.attributes?.custom_package_managements?.data?.attributes?.payment_term?.total_amount)))}`;
    } else {
      return `$ ${formatCurrency.format(Math.round(pkg?.attributes?.total_contract))}`;
    }
  };

  getPackageCardClass = (outerPkg) => {
    const package_ids = this.props.selectedPaymentTerms.map((aa) => {
      return aa.attributes.package_id;
    });
    const { classes } = this.props;
    if (package_ids.indexOf(+outerPkg.id) > -1) {
      return classes.disabledPackageCard;
    } else {
      if (this.props.selectedCurrentPackage?.id === outerPkg?.id) {
        return classes.selectedPackageCard;
      } else {
        return classes.packageCard;
      }
    }
  };

  render() {
    const { classes, theme } = this.props;
    return (
      <>
        <ToggleButton list={["Default Packages", "Custom Packages"]} selectedData={this.props.selectedPackageType} onSelecteData={(value) => this.setSelectedPackage(value)} />

        <Grid container justifyContent="center">
          {this.props.selectedPackageType === 'Default Packages' && <><Grid item xs={12}>
            <Grid container alignItems="stretch">
              <Grid item xs={6} container>
                <Grid item xs={12} container alignItems="center">
                  <CustomTypography className={classes.headingText}>Default Packages</CustomTypography>
                  <CustomColorTooltip
                    title="Client roadmaps can only have a total of 3 options. Options are comprised of a package and its payment. If you want more than one payment term for a single package it will be shown as two options on the Client Roadmap. Example: Business Bundle with monthly payments, Business Bundle with quarterly payments would equal two options on the Client Roadmap. This would leave you with only one space available to add an additional package or payment option."
                    interactive
                    placement="right-end"
                    color={theme.palette.primary.main}
                  >
                    <IconButton disableFocusRipple disableTouchRipple disableRipple aria-label="delete">
                      <InfoOutlinedIcon
                        style={{
                          color: theme.palette.primary.main,
                          fontSize: "1.3rem",
                        }}
                      />
                    </IconButton>
                  </CustomColorTooltip>
                </Grid>
                {/* <Grid item xs={12}>
                <CustomTypography className={classes.headingHelper}>Select up to three packages to include in your Client Roadmap.</CustomTypography>
              </Grid> */}
              </Grid>

              {/* make toggle icon of grid view and list view */}
              <Grid item xs={6} container justifyContent="flex-end">
                <Typography
                  variant="h5"
                  color="primary"
                  style={{
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "1.3rem",
                  }}
                >
                  View Card / List
                  <IconButton
                    onClick={() =>
                      this.setState({
                        viewType: this.state.viewType === "grid" ? "list" : "grid",
                      })
                    }
                    style={{ marginLeft: 8 }}
                    aria-label="toggle view"
                  >
                    {this.state.viewType === "grid" ? (
                      // List icon
                      <img src={ListViewIcon} style={{ width: 24, height: 24 }} />
                    ) : (
                      // Grid icon
                      <img src={GridViewIcon} style={{ width: 24, height: 24 }} />
                    )}
                  </IconButton>
                </Typography>
              </Grid>
              <Snackbar
                open={this.props.isErrorPresent}
                autoHideDuration={6000}
                onClose={(reason) => {
                  if (reason === "clickaway") {
                    return;
                  }
                  this.props.setState({
                    isErrorPresent: false,
                  });
                }}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                style={{
                  marginTop: "80px",
                }}
              >
                <Grid item md={6} xs={12}>
                  <div className={classes.topRightYellowBox}>
                    <WarningIcon />
                    <Typography color="#8C8730" align="center">
                      Client roadmap can only have a total of 3 options. Options are comprised of a package and its' payment term. If you want more than one
                      payment term for a single package it will be shown as two options on the Client Roadmap.
                    </Typography>
                  </div>
                </Grid>
              </Snackbar>
            </Grid>
          </Grid>

            {/* DEFAULT PACKAGES */}

            <Grid item xs={12}>
              <Grid container spacing={this.state.viewType === "grid" ? 3 : 0} className={classes.body}>
                {this.props.packageList.filter((pkg) => pkg?.attributes?.name !== "Default Package").map((m) => {
                  const name = m?.attributes?.custom_package_managements?.data?.attributes?.name ?? m?.attributes?.name;
                  const sharedProps = {
                    image: this.getPackageImage(m?.attributes?.name),
                    name,
                    description: m?.attributes?.description,
                    price: this.getPackagePrices(m),
                    isRecommended: this.props.recommendedPackages.includes(m?.id),
                    cardClassName: this.getPackageCardClass(m),
                    isDisabled: this.props.selectedPaymentTerms.length == 3,
                    onSelect: () => this.selectCurrentPackage(m),
                    onDetail: () => this.openDialogDetail({
                      name: m?.attributes?.name,
                      description: m?.attributes?.description,
                      price: m?.attributes?.custom_package_managements?.data?.attributes?.payment_term?.total_amount ?? m?.attributes?.total_contract,
                      id: m?.id,
                      package: m,
                    }),
                  };
                  return this.state.viewType === "grid"
                    ? <PackageGridCard key={m.id} {...sharedProps} />
                    : <PackageListRow key={m.id} {...sharedProps} />;
                })}
              </Grid>
            </Grid></>}

          {this.props.selectedPackageType === 'Custom Packages' && <><Grid item xs={12}>
            <Grid container alignItems="stretch">
              <Grid item xs={6} container>
                <Grid item xs={12} container alignItems="center">
                  <CustomTypography className={classes.headingText}>Custom Packages</CustomTypography>
                  <CustomColorTooltip
                    title="Client roadmaps can only have a total of 3 options. Options are comprised of a package and its payment. If you want more than one payment term for a single package it will be shown as two options on the Client Roadmap. Example: Business Bundle with monthly payments, Business Bundle with quarterly payments would equal two options on the Client Roadmap. This would leave you with only one space available to add an additional package or payment option."
                    interactive
                    placement="right-end"
                    color={theme.palette.primary.main}
                  >
                    <IconButton disableFocusRipple disableTouchRipple disableRipple aria-label="delete">
                      <InfoOutlinedIcon
                        style={{
                          color: theme.palette.primary.main,
                          fontSize: "1.3rem",
                        }}
                      />
                    </IconButton>
                  </CustomColorTooltip>
                </Grid>
              </Grid>
              {/* make toggle icon of grid view and list view */}
              <Grid item xs={6} container justifyContent="flex-end">
                <Typography
                  variant="h5"
                  color="primary"
                  style={{
                    fontWeight: "bold",
                    fontSize: "1.3rem",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  View Card / List
                  <IconButton
                    onClick={() =>
                      this.setState({
                        viewType: this.state.viewType === "grid" ? "list" : "grid",
                      })
                    }
                    style={{ marginLeft: 8 }}
                    aria-label="toggle view"
                  >
                    {this.state.viewType === "grid" ? (
                      // List icon
                      <img src={ListViewIcon} style={{ width: 24, height: 24 }} />
                    ) : (
                      // Grid icon
                      <img src={GridViewIcon} style={{ width: 24, height: 24 }} />
                    )}
                  </IconButton>
                </Typography>
              </Grid>
            </Grid>
          </Grid>

            {/* CUSTOM PACKAGES */}

            <Grid item xs={12}>
              <Grid container spacing={this.state.viewType === "grid" ? 3 : 0} className={classes.body}>
                {this.props.customPackages.map((customP) => {
                  const sharedProps = {
                    image: customPackage,
                    name: customP?.attributes?.name,
                    description: customP?.attributes?.description,
                    price: new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                      roundingMode: "ceil",
                    }).format(customP?.attributes?.payment_term?.total_amount || 0),
                    cardClassName: this.getPackageCardClass(customP),
                    isDisabled: this.props.selectedPaymentTerms.length == 3,
                    onSelect: () => this.selectCurrentPackage(customP),
                    onDetail: () => this.openDialogDetail({
                      name: customP?.attributes?.name,
                      description: customP?.attributes?.description,
                      price: customP?.attributes?.payment_term?.total_amount,
                      id: customP?.id,
                      package: customP,
                    }),
                  };
                  return this.state.viewType === "grid"
                    ? <PackageGridCard key={customP.id} {...sharedProps} />
                    : <PackageListRow key={customP.id} {...sharedProps} />;
                })}
              </Grid>
            </Grid>
            <Grid item xs={12} justifyContent="center" container>
              <Button
                color="primary"
                startIcon={<ControlPointIcon size="small" />}
                onClick={() => {
                  this.props.createCustomPackage();
                }}
                variant="contained"
              >
                Create Custom Package
              </Button>
            </Grid>
          </>}
          <Grid item xs={12} className={classes.bottomSection}>
            <Grid container direction="row" justifyContent="flex-end">
              <Grid item md={2} xs={12} container justifyContent="flex-end">
                <QuizTooltip title={<QuizDialog classes={classes} />} arrow placement="top-start">
                  <Button
                    color="primary"
                    onClick={() => {
                      this.props.openTakeQuiz({});
                    }}
                    variant="outlined"
                  >
                    {this.props.getQuizText()}
                  </Button>
                </QuizTooltip>
              </Grid>
              <Grid item md={2} xs={12} container justifyContent="flex-end">
                <Button
                  color="primary"
                  onClick={() => {
                    this.props.moveToRoadCustomizationPage();
                    localStorage.setItem('save&next','true')
                  }}
                  variant="contained"
                  disabled={this.props.selectedPaymentTerms.length <= 0}
                >
                  Save & Continue
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }
}

const PackageListWithRouter = withRouter(PackageList);
const PackageListAlertBox = withAlertBox(PackageListWithRouter);
const PackageListLoader = withLoader(PackageListAlertBox);
const PackageListToast = withToast(PackageListLoader);
const PackageListWithDialog = withDialog(PackageListToast);

export default withStyles(
  (theme) =>
    createStyles({
      body: {
        marginTop: theme.spacing(2.5),
        marginBottom: theme.spacing(2.5),
        [theme.breakpoints.down("md")]: {
          margin: 0,
          marginBottom: theme.spacing(1.4),
        },
      },
      packageCard: {
        padding: "5px",
        borderRadius: "1rem",
        backgroundColor: "#ffffff",
        boxShadow: "rgba(149, 157, 165, 0.25) 0px 8px 12px",
      },
      disabledPackageCard: {
        padding: theme.spacing(1),
        borderRadius: "1rem",
        backgroundColor: "#ccc",
        pointerEvents: "none",
        opacity: 0.4,
        boxShadow: "rgba(149, 157, 165, 0.25) 0px 8px 12px",
      },
      selectedPackageCard: {
        padding: theme.spacing(1),
        borderRadius: "1rem",
        backgroundColor: "#F1F1F1",
        boxShadow: "rgba(149, 157, 165, 0.25) 0px 8px 12px",
      },
      dialogBox: {
        width: "250px",
      },
      tooltipHeading: {
        color: theme.palette.text.blue2,
        fontSize: "1rem",
      },
      bulbIcon: {
        width: "45px",
        height: "50px",
      },
      topRightYellowBox: {
        backgroundColor: "#FEF9A2",
        borderRadius: theme.spacing(2),
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: theme.spacing(2),
        "& p": {
          fontSize: "0.9rem",
        },
        "& svg": {
          fill: "#BFB428",
          fontSize: "1.875rem",
        },
      },
      bottomSection: {
        [theme.breakpoints.up("md")]: {
          marginTop: theme.spacing(4),
          marginBottom: theme.spacing(6),
        },
        [theme.breakpoints.down("xs")]: {
          marginTop: theme.spacing(2),
        },
      },
      headingText: {
        fontFamily: "Lato",
        fontSize: "1.3rem",
        fontWeight: "bold",
        color: theme.palette.primary.main,
        // letterSpacing: 1.5,
        marginBottom: "0.5rem",
      },
      headingHelper: {
        fontFamily: "Lato",
        fontSize: "1rem",
        color: theme.palette.text.secondary,
      },
    }),
  { withTheme: true }
)(withConfirmBox(PackageListWithDialog));
